<template>
  <div></div>
</template>

<script>
  export default {
    name: 'App-Update',
    data () {
      return {
        timer: null,
        interval: 5 * 60 * 1000 // 5 minutes
      };
    },
    created () {
      if (process.env.NODE_ENV === 'development') {
        return;
      }

      this.timer = setInterval(this.check, this.interval);
    },
    methods: {
      async check () {
        try {
          const
            manifest = document.querySelector('script[src^="/static/js/manifest"]').getAttribute('src'),
            version  = manifest.match(/\.(.+)\.js$/)[1],
            pattern  = new RegExp('manifest.' + version + '.js.map')
          ;

          const res = await this.$http.get(manifest + '?' + Date.now());
          if (!pattern.test(res.body)) {
            throw new Error('version mismatch');
          }
        } catch (e) {
          if (e.status === 404) {
            clearInterval(this.timer);
            this.alert();
          }
        }
      },
      alert () {
        this.$bvToast.toast('Klicke hier um die neue Version zu laden.', {
          title: 'Neue Version von Gunfinder verfügbar!',
          variant: 'warning',
          href: '/',
          noAutoHide: true
        });
      }
    }
  };
</script>
